import { render, staticRenderFns } from "./ExpiringIssues.vue?vue&type=template&id=0afe5e27&scoped=true"
import script from "./ExpiringIssues.vue?vue&type=script&lang=js"
export * from "./ExpiringIssues.vue?vue&type=script&lang=js"
import style0 from "./ExpiringIssues.vue?vue&type=style&index=0&id=0afe5e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe5e27",
  null
  
)

export default component.exports